import React from 'react';

import type { PlannerLaneMapSlot } from '@hopdrive/feature-move-planner';

import MovePlannerLaneMap from '@features/moveCreation/components/MovePlannerLaneMap';

const MAP_VISIBLE_KEY = 'lane-planner-map-visible';

/** The dealer's lane map for the planner, with the user's remembered choice to show it. */
export function useLaneMapSlot(): PlannerLaneMapSlot {
  const [visible, setVisible] = React.useState(() => {
    try {
      const stored = localStorage.getItem(MAP_VISIBLE_KEY);
      return stored === 'true';
    } catch {
      return false;
    }
  });

  return React.useMemo(
    () => ({
      Map: MovePlannerLaneMap,
      visible,
      onToggle: () => {
        const next = !visible;
        setVisible(next);
        try {
          localStorage.setItem(MAP_VISIBLE_KEY, String(next));
        } catch {
          /* noop */
        }
      },
    }),
    [visible]
  );
}
